/**
 * API接口配置常量定义
 */

export const API_CATEGORIES = {
  ADMIN: "管理员管理",
  ROLE: "角色管理",
  PERMISSION: "权限管理",
  OPERATION: "授权操作",
  SERVICE: "微服务管理",
  TOKEN: "Token管理",
  AUTH: "认证授权",
  CONFIG: "配置管理",
  MICROSERVICE: "微服务配置",
} as const;

// 一级分类配置（可折叠的一级分类）
export const API_CATEGORY_GROUPS = {
  USER_MANAGEMENT: '用户权限管理',
  SYSTEM_CONFIG: '系统配置管理',
  SERVICE: '服务管理',
} as const;

// 一级分类分组映射
export const CATEGORY_GROUP_MAPPING: Record<string, string> = {
  [API_CATEGORIES.ADMIN]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.ROLE]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.PERMISSION]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.OPERATION]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.TOKEN]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.AUTH]: API_CATEGORY_GROUPS.USER_MANAGEMENT,
  [API_CATEGORIES.CONFIG]: API_CATEGORY_GROUPS.SYSTEM_CONFIG,
  [API_CATEGORIES.MICROSERVICE]: API_CATEGORY_GROUPS.SERVICE,
  [API_CATEGORIES.SERVICE]: API_CATEGORY_GROUPS.SERVICE,
};

